import { render, staticRenderFns } from "./InteractionContainer.vue?vue&type=template&id=2b1586e3"
import script from "./InteractionContainer.vue?vue&type=script&lang=js"
export * from "./InteractionContainer.vue?vue&type=script&lang=js"
import style0 from "./InteractionContainer.vue?vue&type=style&index=0&id=2b1586e3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports